import { createElement } from 'react'
import { attributesToProps, DOMNode, domToReact, HTMLReactParserOptions } from 'html-react-parser'
import { PopulatedLocation } from 'components/producers/new-producer-map/types'
import { RootState, store } from 'store'
import { getCapacityState } from 'utils/producers'

/**
 * Strips styles from all HTML nodes and returns a React element without inline styles.
 * @param {DOMNode} node
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>}
 */
export const stripStyles: HTMLReactParserOptions['replace'] = (node) => {
  if ('attribs' in node && node.type === 'tag' && node.name !== 'br' && node.name !== 'img' && node.name !== 'hr') {
    const { style, children, ...props } = attributesToProps(node.attribs)
    return createElement(node.name, props, domToReact(node.children as DOMNode[], { replace: stripStyles }))
  }
}

/**
 * Filters locations based on the hideSoldOutLocations flag
 *
 * @param {PopulatedLocation[]} locations
 * @param {boolean} hideSoldOutLocations
 * @returns {PopulatedLocation[]}
 */
export const filterLocations = (locations: PopulatedLocation[], hideSoldOutLocations: boolean): PopulatedLocation[] => {
  if (!hideSoldOutLocations || !store) return locations

  const { inputs, flows } = (store.getState() as RootState).customer

  return locations.filter((location) => {
    const capacity = getCapacityState(location, inputs.simulation, flows.simulation.didSimulation)

    return !capacity.soldOut
  })
}
